<script setup>   
    import { inject, computed } from 'vue';
    import AchievementTable from '@/components/result/ai-literacy/AchievementTable.vue';
    import AchievementInfo from '@/components/result/ai-literacy/AchievementInfo.vue'; 
    import Overview from '@/components/result/ai-literacy/Overview.vue'; 

    const userRole = 'principal';
    
    // 부모 컴포넌트에서 전달받은 데이터
    const principalData = inject('principalData');
    const schoolData = inject('schoolData');
    
    // 학급수와 응시 학생수 계산
    const schoolInfo = computed(() => {
        if (!principalData.value || !principalData.value.classList) {
            return {
                classCount: 0,
                studentCount: 0,
                schoolType: '',
                grade: ''
            };
        }
        
        const classList = principalData.value.classList;
        const totalStudents = classList.reduce((sum, classItem) => sum + (classItem.total_cnt || 0), 0);
        
        // 학교 유형 (초등학교/중학교) 판단
        const schoolType = schoolData.value?.schul_type || '';
        const grade = schoolData.value?.grade_code || '';
        
        return {
            classCount: classList.length,
            studentCount: totalStudents,
            schoolType: schoolType === 'elementary' ? '초등학교' : schoolType === 'middle' ? '중학교' : schoolType,
            grade: grade
        };
    });
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">           
            <AchievementTable :userRole="userRole" />      
            <AchievementInfo 
                :class-count="schoolInfo.classCount"
                :student-count="schoolInfo.studentCount"
                :school-type="schoolInfo.schoolType" 
                :grade="schoolInfo.grade"
            />         
           <Overview 
                view-type="school" 
                :principalData="principalData"
                :schoolData="schoolData"
            />
        </div>
    </div>
</template>